import type { ServerResponse } from "@/http"
import type { IEventTypeResponse } from "@/models"
import { useQuery } from "@tanstack/vue-query"
import { axios } from "@/axios"
import { EventType } from "@/models"

export async function listEventTypes() {
  const response = await axios.get<ServerResponse<IEventTypeResponse[]>>("/api/event/types")

  return response.data.Data?.map((eventType: IEventTypeResponse) => EventType.fromResponse(eventType)) ?? []
}

const LIST_EVENT_TYPES_KEY = "listEventTypes"

export function useListEventTypes() {
  return useQuery({
    queryKey: [LIST_EVENT_TYPES_KEY],
    queryFn: listEventTypes,
  })
}
